/**
 * API Client (Legacy/Generic)
 *
 * Generic API client for backward compatibility
 * Uses the unified API client factory for consistent behavior
 *
 * @deprecated Use specific clients (userManagementClient, publisherClient) instead
 */

import { API_CONFIG } from './config';
import { createApiClient } from './clients/api-client-factory';

/**
 * Generic API Client (Legacy)
 * For books and other generic endpoints
 *
 * Note: Token refresh endpoint may need adjustment based on actual API
 */
const apiClient = createApiClient({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  withRefreshToken: true,
  refreshEndpoint: '/auth/refresh', // Legacy endpoint
});

export default apiClient;
